
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuotteet/[slug]",
      function () {
        return require("private-next-pages/tuotteet/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuotteet/[slug]"])
      });
    }
  